import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { workspaceScale } from '../shared/utils/workspace-sizing';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService implements OnDestroy {
  private resizeFrame: number | null = null;
  private readonly onResize = () => {
    if (this.resizeFrame !== null) return;
    this.resizeFrame = requestAnimationFrame(() => {
      this.resizeFrame = null;
      this.update();
    });
  };

  private isMobileSubject =
    new BehaviorSubject<boolean>(window.innerWidth <= 740);

  private isLaptopSubject =
    new BehaviorSubject<boolean>(
      window.innerWidth > 740 &&
      window.innerWidth <= 1440
    );

  private appScaleSubject =
    new BehaviorSubject<number>(this.calculateScale());

  isMobile$ = this.isMobileSubject.asObservable();
  isLaptop$ = this.isLaptopSubject.asObservable();
  appScale$ = this.appScaleSubject.asObservable();

  constructor() {

    // Observe the viewport, not the body whose size is changed by scaling itself.
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
    if (this.resizeFrame !== null) cancelAnimationFrame(this.resizeFrame);
  }

  private update(): void {

    const width = window.innerWidth;

    if (this.isMobileSubject.value !== (width <= 740)) this.isMobileSubject.next(width <= 740);

    const laptop = width > 740 && width <= 1440;
    if (this.isLaptopSubject.value !== laptop) this.isLaptopSubject.next(laptop);

    const scale = this.calculateScale();
    if (this.appScaleSubject.value !== scale) this.appScaleSubject.next(scale);
  }

  private calculateScale(): number {

    return workspaceScale(window.innerWidth, window.innerHeight,
      window.matchMedia('(pointer: coarse)').matches);
  }
}
